import { walletConnection } from '../actions/type';
import StorageService from '../services/storage.service';

const wallet = StorageService.getObject('wallet');

const initialState =
  wallet != null && wallet.walletAddress != null
    ? {
        walletConnected: true,
        wallet,
      }
    : {
        walletConnected: false,
        wallet,
      };

function connectWallet(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case walletConnection.SUCCESS:
      return {
        ...state,
        walletConnected: true,
        wallet: payload,
      };
    case walletConnection.DISCONNECT:
      return {
        ...state,
        walletConnected: false,
        wallet: payload,
      };
    default:
      return state;
  }
}

export default connectWallet;
